import React, { useState, useEffect } from 'react';
import SearchKeyword from '../common/SearchKeyword';
import thumb_img from '../../../assets/images/board_thumb_default.png';
import Pagination from '../common/Pagination';
import DetailPopup from '../common/DetailPopup';

export default function Content() {
  const [searchParams, setSearchParams] = useState({
    filter: 'title',
    keyword: '',
  });

  const [eventList, setEventList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const customFilterOptions = [
    { value: 'title', label: '제목' },
    { value: 'content', label: '내용' },
    { value: 'all', label: '제목+내용' },
  ];

const fetchEventList = async (page = 1, searchData = searchParams) => {
  setLoading(true);
  try {
    const params = new URLSearchParams();
    params.set('curPage', page);

    if (searchData.keyword && searchData.keyword.trim()) {
      params.set('keyword', searchData.keyword.trim());
      params.set('filter', searchData.filter);
    }

   
    const categoryId = 1; 
    const apiUrl = `/api/event/cateId/${categoryId}?${params}`;
    console.log('API 요청 URL:', apiUrl);

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers.get('content-type'));

    // 응답이 JSON인지 확인
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const textResponse = await response.text();
      console.error('JSON이 아닌 응답:', textResponse);
      throw new Error(`서버에서 JSON이 아닌 응답을 반환했습니다. Content-Type: ${contentType}`);
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('=== 응답 데이터 ===', data);

    // 컨트롤러에서 이미 카테고리별로 필터링된 데이터를 반환하므로 
    // 프론트엔드에서 추가 필터링 불필요
    const filteredList = data.list || [];
    
    setEventList(filteredList);

    if (data.pagination) {
      setTotalPages(data.pagination.totalPages || 1);
      setCurrentPage(data.pagination.currentPage || page);
    } else {
      setTotalPages(1);
      setCurrentPage(page);
    }

    console.log('최종 설정:', {
      listLength: filteredList.length,
      totalPages: data.pagination?.totalPages || 1,
      currentPage: data.pagination?.currentPage || page
    });

  } catch (error) {
    console.error('이벤트 목록 조회 상세 오류:', {
      message: error.message,
      stack: error.stack,
      apiUrl: `/api/event/cateId/1?curPage=${page}`
    });
    
    setEventList([]);
    setTotalPages(1);
    setCurrentPage(1);
    
   alert('이벤트 목록을 불러오는 중 오류가 발생했습니다.');
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchEventList(1);
  }, []);

  const handleSearch = (searchData) => {
    setSearchParams(searchData);
    setCurrentPage(1);

    const params = new URLSearchParams();
    params.set('curPage', '1');

    if (searchData.keyword) {
      params.set('keyword', searchData.keyword);
      params.set('filter', searchData.filter);
    }

    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${params}`
    );

    fetchEventList(1, searchData);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);

    const params = new URLSearchParams(window.location.search);
    params.set('curPage', page);

    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${params}`
    );

    fetchEventList(page);
  };

  const handleEventClick = (eventData) => {
    const detailData = {
      title: eventData.title || eventData.TITLE || '이벤트 제목입니다.',
      subtitle: eventData.subtitle || eventData.STATUS || '뉴스/소식',
      videoUrl: eventData.videoUrl || eventData.VIDEO_URL,
      content:
        eventData.content ||
        eventData.CONTENT ||
        `이벤트 내용입니다. 이벤트 내용입니다. 이벤트 내용입니다. 
                이벤트 내용입니다. 이벤트 내용입니다. 이벤트 내용입니다. 이벤트 내용입니다. 
                이벤트 내용입니다. 이벤트 내용입니다. 이벤트 내용입니다.`,
      imageUrl: eventData.imageUrl || eventData.IMAGE_URL,
    };
    setSelectedEvent(detailData);
    setIsDetailOpen(true);
  };
  
  // 이미지 URL 처리 함수
  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return thumb_img;
    return `/resources/upload/${imageUrl}`;
  };

  return (
    <>
      <div className="s3_1_content">
        <SearchKeyword
          onSearch={handleSearch}
          placeholder="검색하세요"
          filterOptions={customFilterOptions}
          initialFilter="title"
        />
        <div className="center txt-left">
          {loading && <div>로딩 중...</div>}

          <div className="mt-4">
            <div className="board_wrap mb-5">
              <div className="row-flex-center gap-30 flex-wrap">
                {eventList.length > 0
                  ? eventList.map((event, index) => (
                      <div
                        key={event.id || event.ID || index}
                        className="board_item pointer"
                        onClick={() => handleEventClick(event)}
                      >
                        <div className="board_img w-100">
                          <img
                            src={getImageUrl(event.imageUrl || event.IMAGE_URL)}
                            alt={event.title || event.TITLE || '이벤트 이미지'}
                            onError={(e) => {
                              e.target.src = thumb_img;
                            }}
                          />
                        </div>
                        <p className="prt-semi-bold txt-left fs-20 fc-black1 mt-2 mb-5 txt-ellipsis">
                          {event.title || event.TITLE || '제목 없음'}
                        </p>
                      </div>
                    ))
                  : !loading && (
                       <div className="flex-center prt-light fc-45 fs-20 txt-center w-100">
                        <p>글이 없습니다.</p>
                      </div>
                    )}
              </div>
            </div>

            {eventList.length > 0 && totalPages > 1 && (
              <div className="pagination row-flex-center">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <DetailPopup
        isOpen={isDetailOpen}
        onClose={() => setIsDetailOpen(false)}
        data={selectedEvent}
      />
    </>
  );
}